import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LangConstant, SystemConstant } from "const";
import { ReInviteIcon } from "theme/images";
import { useInviteUser, useRole } from "hooks";

const UserStatusJoin = ({ user, enableAction }) => {
  const { t: getLabel } = useTranslation();
  const { inviteUser } = useInviteUser();
  const { isServiceAdmin } = useRole();

  const handleInviteUser = () => {
    inviteUser({
      phone: user.phone,
    });
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {enableAction !== false && !isServiceAdmin ? (
        <button
          className="btn btn-icon btn-ghost-secondary"
          style={{ border: "1px solid #D4D5D8", width: "32px", height: "32px" }}
          title={getLabel(LangConstant.TXT_INVITE_AGAIN)}
          onClick={handleInviteUser}
        >
          <ReInviteIcon width={28} height={28} />
        </button>
      ) : (
        ""
      )}
    </div>
  );
};

export default UserStatusJoin;
